/* Cagoule-Shop : liens d'aide sous le bouton d'achat (guide des tailles + questionnaire).
   La barre d'achat fixe est deja fournie par l'appli d'offres groupees, celle du theme reste masquee. */
(function () {
  var KIDS = /enfant|fille|gar[çc]on|b[ée]b[ée]|panda|cartoon/i;

  function addHelp(main) {
    var form = main.closest('form');
    if (!form || form.parentNode.querySelector('.ux-help')) return;
    var titleEl = document.querySelector('.product__title h1, .product__title');
    var title = titleEl ? titleEl.textContent : '';
    var html = '<div class="ux-trust"><span>🚚 Livraison suivie en 5 à 10 jours ouvrés</span><span>🔒 Paiement sécurisé</span><span>↩️ Retour possible sous 14 jours</span></div>';
    if (!KIDS.test(title)) {
      html += '<a href="/blogs/blog/quelle-taille-de-cagoule-choisir-pour-un-adulte"><span aria-hidden="true">📏</span><span>Un doute sur la taille ? <strong>Voir notre guide des tailles</strong></span></a>';
    }
    html += '<a href="/pages/quelle-cagoule-choisir"><span aria-hidden="true">🧭</span><span>Pas sûr de votre choix ? <strong>Trouvez votre cagoule en 3 questions</strong></span></a>';
    var help = document.createElement('div');
    help.className = 'ux-help';
    help.innerHTML = html;
    form.parentNode.insertBefore(help, form.nextSibling);
  }

  function run() {
    document.querySelectorAll('button[name="add"].product-form__submit').forEach(addHelp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
